import React from 'react'
import PropTypes from 'prop-types'
import NavbarTopDesktop from './NavbarTopDesktop'

NavbarTopContainer.propTypes = {
    onClick: PropTypes.func.isRequired,
    isCollapsed: PropTypes.bool.isRequired
}

function NavbarTopContainer(props) {
    return (
        <div className="NavBarSection">
            <NavbarTopDesktop
                {...props}
            />
        </div>
    )
}

export default NavbarTopContainer
